import React, { useState } from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { YouCard, SubScreenHeader } from './YouPrimitives';

const TEXT_SECONDARY = 'rgba(255,255,255,0.7)';
const TEXT_TERTIARY = 'rgba(255,255,255,0.4)';

export default function FaqSection({ items = [], onBack }) {
  const [openId, setOpenId] = useState(null);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <SubScreenHeader title="FAQ" onBack={onBack} />

      {items.length === 0 ? (
        <Typography sx={{ textAlign: 'center', fontSize: 13, color: TEXT_TERTIARY }}>
          No questions yet
        </Typography>
      ) : (
        <YouCard sx={{ padding: '4px' }}>
          {items.map((item) => {
            const open = openId === item.id;
            return (
              <Box key={item.id}>
                <ButtonBase
                  aria-expanded={open}
                  onClick={() => setOpenId(open ? null : item.id)}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    width: '100%',
                    padding: '14px',
                    borderRadius: '10px',
                    textAlign: 'left',
                    justifyContent: 'flex-start',
                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.06)' },
                  }}
                >
                  <Typography sx={{ flex: 1, minWidth: 0, fontSize: 15, fontWeight: 500, color: '#fff' }}>
                    {item.title}
                  </Typography>
                  <ExpandMoreIcon
                    sx={{
                      fontSize: 20,
                      color: TEXT_TERTIARY,
                      flexShrink: 0,
                      transition: 'transform 150ms',
                      transform: open ? 'rotate(180deg)' : 'none',
                    }}
                  />
                </ButtonBase>

                {open && (
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 300,
                      color: TEXT_SECONDARY,
                      whiteSpace: 'pre-wrap',
                      padding: '0 14px 14px',
                    }}
                  >
                    {item.body}
                  </Typography>
                )}
              </Box>
            );
          })}
        </YouCard>
      )}
    </Box>
  );
}
